var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayNextOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 5.09998C3.38376 5.09998 3 5.50292 3 5.99998C3 6.49703 3.38376 6.89998 3.85714 6.89998H18.1429C18.6162 6.89998 19 6.49703 19 5.99998C19 5.50292 18.6162 5.09998 18.1429 5.09998H3.85714Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86932 10.1C3.38921 10.1 3 10.5029 3 11C3 11.497 3.38921 11.9 3.86932 11.9H11.1307C11.6108 11.9 12 11.497 12 11C12 10.5029 11.6108 10.1 11.1307 10.1H3.86932Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 15.5029 3.38921 15.1 3.86932 15.1H11.1307C11.6108 15.1 12 15.5029 12 16C12 16.497 11.6108 16.9 11.1307 16.9H3.86932C3.38921 16.9 3 16.497 3 16Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4933 16.9646C22.1689 16.5175 22.1689 15.4825 21.4933 15.0354L15.6632 11.1772C14.9407 10.6991 14 11.2447 14 12.1418V19.8582C14 20.7553 14.9407 21.3009 15.6632 20.8228L21.4933 16.9646Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNextOutline);
export default __webpack_public_path__ + "static/media/play_next_outline.6064ab4157b530f402b927914c2e3202.svg";
export { ForwardRef as ReactComponent };